import styled from "styled-components";

export const DerivativeSection = styled.div`

`;
